/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Test_Sent_To_DevicesInputs */

const th_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ส่งไปยัง ${i?.count} อุปกรณ์แล้ว หากไม่มีการแจ้งเตือนปรากฏ ให้ตรวจสอบการอนุญาตแจ้งเตือนของแอปนี้ในการตั้งค่าระบบ`)
};

const en_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent to ${i?.count} device(s). If nothing appears, check notification permissions for this app in your system settings.`)
};

const ja_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}台の端末に送信しました。通知が表示されない場合は、システム設定でこのアプリの通知許可を確認してください。`)
};

const zh_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已发送至 ${i?.count} 台设备。若没有出现，请在系统设置中检查此应用的通知权限。`)
};

const es_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviada a ${i?.count} dispositivo(s). Si no aparece nada, comprueba los permisos de notificación de esta aplicación en los ajustes del sistema.`)
};

const pt_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviada para ${i?.count} dispositivo(s). Se nada aparecer, confira as permissões de notificação deste aplicativo nas configurações do sistema.`)
};

const id_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terkirim ke ${i?.count} perangkat. Jika tidak ada yang muncul, periksa izin notifikasi aplikasi ini di Pengaturan Sistem.`)
};

const fr_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Envoyée à ${i?.count} appareil(s). Si rien n’apparaît, vérifiez les autorisations de notification de cette application dans les réglages du système.`)
};

const tl_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Naipadala sa ${i?.count} device. Kung walang lumitaw, suriin ang pahintulot sa notipikasyon ng app na ito sa System Settings.`)
};

const vi_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã gửi tới ${i?.count} thiết bị. Nếu không thấy gì, hãy kiểm tra quyền thông báo của ứng dụng này trong Cài đặt hệ thống.`)
};

const ko_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}개 기기로 보냈습니다. 아무것도 나타나지 않으면 시스템 설정에서 이 앱의 알림 권한을 확인하세요.`)
};

const de_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An ${i?.count} Gerät(e) gesendet. Wenn nichts erscheint, prüfe die Benachrichtigungsrechte dieser App in den Systemeinstellungen.`)
};

const ru_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправлено на ${i?.count} устройств. Если ничего не появилось, проверьте разрешения на уведомления для этого приложения в системных настройках.`)
};

const tr_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cihaza gönderildi. Hiçbir şey görünmezse Sistem Ayarları'ndan bu uygulamanın bildirim izinlerini kontrol edin.`)
};

const it_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inviata a ${i?.count} dispositivi. Se non compare nulla, controlla i permessi di notifica di questa app in Impostazioni di Sistema.`)
};

const pl_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wysłano na ${i?.count} urządzeń. Jeśli nic się nie pojawi, sprawdź uprawnienia do powiadomień tej aplikacji w Ustawieniach systemowych.`)
};

const uk_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Надіслано на ${i?.count} пристроїв. Якщо нічого не з'явилося, перевірте дозволи на сповіщення для цього застосунку в системних налаштуваннях.`)
};

const hi_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} उपकरणों पर भेजा गया। अगर कुछ न दिखे, तो सिस्टम सेटिंग्स में इस ऐप की सूचना अनुमतियाँ जाँचें।`)
};

const ar_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أُرسل إلى ${i?.count} من الأجهزة. إن لم يظهر شيء، تحقق من أذونات الإشعارات لهذا التطبيق في إعدادات النظام.`)
};

const ms_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dihantar ke ${i?.count} peranti. Jika tiada apa muncul, semak kebenaran pemberitahuan aplikasi ini dalam Tetapan Sistem.`)
};

const bn_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}টি যন্ত্রে পাঠানো হয়েছে। কিছু না দেখা গেলে সিস্টেম সেটিংসে এই অ্যাপের বিজ্ঞপ্তির অনুমতি দেখুন।`)
};

const zh_tw2_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已送至 ${i?.count} 台裝置。若沒有出現，請在系統設定中檢查這個應用程式的通知權限。`)
};

const zh_hk2_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已送至 ${i?.count} 台裝置。若沒有出現，請在系統設定中檢查這個應用程式的通知權限。`)
};

const ur_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} آلات پر بھیجا گیا۔ اگر کچھ نہ دکھے تو سسٹم کی ترتیبات میں اس ایپ کی اطلاعات کی اجازت دیکھیں۔`)
};

const fa_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`به ${i?.count} دستگاه فرستاده شد. اگر چیزی دیده نشد، اجازه‌های اعلان این برنامه را در تنظیمات سامانه بررسی کنید.`)
};

const sw_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imetumwa kwa vifaa ${i?.count}. Kama hakuna kinachoonekana, angalia ruhusa za arifa za programu hii kwenye Mipangilio ya Mfumo.`)
};

const nl_test_sent_to_devices = /** @type {(inputs: Test_Sent_To_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verstuurd naar ${i?.count} apparaten. Als er niets verschijnt, controleer dan de meldingsrechten van deze app in Systeeminstellingen.`)
};

/**
* | output |
* | --- |
* | "Sent to {count} device(s). If nothing appears, check notification permissions for this app in your system settings." |
*
* @param {Test_Sent_To_DevicesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_sent_to_devices = /** @type {((inputs: Test_Sent_To_DevicesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_Sent_To_DevicesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_sent_to_devices(inputs)
	if (locale === "ja") return ja_test_sent_to_devices(inputs)
	if (locale === "zh") return zh_test_sent_to_devices(inputs)
	if (locale === "es") return es_test_sent_to_devices(inputs)
	if (locale === "pt") return pt_test_sent_to_devices(inputs)
	if (locale === "id") return id_test_sent_to_devices(inputs)
	if (locale === "fr") return fr_test_sent_to_devices(inputs)
	if (locale === "tl") return tl_test_sent_to_devices(inputs)
	if (locale === "vi") return vi_test_sent_to_devices(inputs)
	if (locale === "ko") return ko_test_sent_to_devices(inputs)
	if (locale === "de") return de_test_sent_to_devices(inputs)
	if (locale === "ru") return ru_test_sent_to_devices(inputs)
	if (locale === "tr") return tr_test_sent_to_devices(inputs)
	if (locale === "it") return it_test_sent_to_devices(inputs)
	if (locale === "pl") return pl_test_sent_to_devices(inputs)
	if (locale === "uk") return uk_test_sent_to_devices(inputs)
	if (locale === "hi") return hi_test_sent_to_devices(inputs)
	if (locale === "ar") return ar_test_sent_to_devices(inputs)
	if (locale === "ms") return ms_test_sent_to_devices(inputs)
	if (locale === "bn") return bn_test_sent_to_devices(inputs)
	if (locale === "zh-TW") return zh_tw2_test_sent_to_devices(inputs)
	if (locale === "zh-HK") return zh_hk2_test_sent_to_devices(inputs)
	if (locale === "ur") return ur_test_sent_to_devices(inputs)
	if (locale === "fa") return fa_test_sent_to_devices(inputs)
	if (locale === "sw") return sw_test_sent_to_devices(inputs)
	if (locale === "nl") return nl_test_sent_to_devices(inputs)
	return en_test_sent_to_devices(inputs)
});